import { SaveAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import Swal from 'sweetalert2';
import { TaxService } from '../TaxService';
import stateList from '../../../../utils/stateList.json';

const ExportAll = (props) => {
  const { paginationModel } = props;

  // Define custom headers and their corresponding data mapping
  const exportMapping = [
    {
          header: 'SL. NO.',
          value: (row, index) => `${index + 1}`
        },
        {
          header: 'Invoice Number',
          value: (row) => `${row.invoiceNumber}`
        },
        {
          header: 'Invoice Type',
          value: (row) => `CuDel Expert Wallet Invoice`
        },
        {
          header: 'Service',
          value: (row) => `Subscription Charge`
        },
        {
          header: 'Month/Year',
          value: (row) => `${row?.month
                            ? new Date(row.year, row.month - 1).toLocaleString('default', { month: 'short' })
                            : ''}, ${row.year}`
        },
        {
          header: 'State Code',
          value: (row) => `${stateList.find(s => s.name == row?.expert?.UserAddress?.state)?.code || ''}`
        },
        {
          header: 'Client Name',
          value: (row) => `${row.expert.UserProfile?.firstName ||''} ${row.expert.UserProfile?.middleName ||''} ${row.expert.UserProfile?.lastName ||''}`
        },
        {
          header: 'Client GST Number',
          value: (row) => `${row.expert.UserBusinessDetail?.gstNumber || ''}`
        },
        {
          header: 'Client PAN NUMBER',
          value: (row) => `${row.expert.UserBusinessDetail?.panNumber || ''}`
        },
        {
          header: 'Client Adress',
          value: (row) => `${row?.expert?.UserAddress?.address || ''}`
        },
        {
          header: 'Base Amount',
          value: (row) => `${row.baseAmount}`
        },
        {
          header: 'Disc. Amount',
          value: (row) => `${row.discountAmount}`
        },
        {
          header: 'TAXABLE',
          value: (row) => `${row.taxableAmount || ''}`
        },
        {
          header: 'IGST',
          value: (row) => `${row.igst || ''}`
        },
        {
          header: 'CGST',
          value: (row) => `${row.cgst || ''}`
        },
        {
          header: 'SGST',
          value: (row) => `${row.sgst || ''}`
        },
        {
          header: 'Total GST',
          value: (row) => `${row.totalTax || ''}`
        },
        {
          header: 'Total Amount',
          value: (row) => `${row.billingAmount || ''}`
        },
        {
          header: 'Rate',
          value: (row) => `18%`
        },
        {
          header: 'Opening Balance',
          value: (row) => `${row.openingBalance || ''}`
        },
        {
          header: 'Total Debited Amount',
          value: (row) => `${row.totalDebitAmount || ''}`
        },{
          header: 'Total Credited Amount',
          value: (row) => `${row.totalCreditAmount || ''}`
        },
        {
          header: 'Closing Balance',
          value: (row) => `${row.closingBalance || ''}`
        },
        {
          header: 'REMARKS',
          value: (row) => `${row.remark || ''}`
        },
  ];

  const handleExportAllRows = async () => {
    try {
      Swal.fire({
        title: 'Exporting Data',
        text: 'Please wait while we prepare your download...',
        icon: 'info',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const listResponse = await TaxService.fetchWalletSummaryExportList({
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortBy: paginationModel.filters.sortBy,
          sortType: paginationModel.filters.sortType,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      });

      // Transform data using custom mapping
      const exportData = listResponse.data.list.map((row, index) => {
        return exportMapping.reduce((acc, field) => {
          acc[field.header] = field.value(row, index);
          return acc;
        }, {});
      });

      // Create CSV content
      const headers = exportMapping.map(field => `"${field.header}"`).join(',');
      const csvContent = exportData.map(row => 
        exportMapping.map(field => 
          `"${String(row[field.header] ?? '').replace(/"/g, '""')}"`
        ).join(',')
      );

      csvContent.unshift(headers);

      // Create and download file
      const csvString = '\uFEFF' + csvContent.join('\n');
      const blob = new Blob(['﻿', csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Expert-wallet-monthly-report.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      Swal.fire({
        title: 'Export Successful',
        html: `
          <p>If download doesn't start automatically, click on provided link:
          <a href="${url}" download="Expert-Wallet-Summary-report.csv" style="color: blue; text-decoration: underline;">
            Download CSV
          </a></p>
        `,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });

    } catch (error) {
      console.error('Export failed', error);
      
      Swal.fire({
        title: 'Export Failed',
        text: 'There was an issue exporting the data. Please try again.',
        icon: 'error'
      });
    }
  };

  return (
    <Box>        
      <Button 
        onClick={handleExportAllRows}
        startIcon={<SaveAlt />}
        sx={{textTransform:'none'}}
      >
        Export
      </Button>      
    </Box>
  );
}

export default ExportAll;